import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, map, startWith } from 'rxjs';
import { FileService } from 'src/app/services/api/file.service';
import { FunctionsService } from 'src/app/services/api/functions.service';
import { CognitoService } from 'src/app/services/cognito.service';
import {
  GetProvidersByServiceEnvelope,
  isProvidersEmptySuccess,
  isProvidersFound,
  toProvidersByServiceClientError
} from 'src/features/file-services/manage-provider/lib/get-providers-by-service';
import Swal from 'sweetalert2';

export interface providerInfo {
  tipoProveedor: String;
  id: string;
  nombre: String;
  oldServiceId: string;
  servicioId?: string;
}

@Component({
  selector: 'app-dialog-provider',
  templateUrl: './dialog-provider.component.html',
  styleUrls: ['./dialog-provider.component.css']
})
export class DialogProviderComponent implements OnInit {
  providerList: providerInfo[] = [];
  infoProvider: any = '';
  myControl = new FormControl<string | any>('', { nonNullable: true });
  isLoading = false;
  isLoadingResult = false;
  messageResult: string | null = null;
  iconResult: boolean | null = null;
  showModal = false;
  /** Mensaje del back para empty/info (no hardcodear). */
  providersMessage: string | null = null;
  providersEmpty = false;
  nombreServicioInvalid = false;
  nombreServicio = '';
  categoriaServicio = '';
  user: string | null = null;
  locacion = '';

  filteredOptions!: Observable<any>;

  constructor(
    public dialogRef: MatDialogRef<DialogProviderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fileService: FileService,
    private service: FunctionsService,
    public Cognito: CognitoService
  ) {}

  ngOnInit(): void {
    this.user = localStorage.getItem('email');

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value) => {
        const nombre = typeof value === 'string' ? value : value?.nombre;
        return nombre
          ? this._filter(nombre as string)
          : this.providerList?.slice();
      })
    );

    this.nombreServicio = this.data.nombreServicio;
    this.categoriaServicio = this.data.categoriaServicio
      ? this.data.categoriaServicio
      : '';
    this.locacion = this.data.locacion ? this.data.locacion : '';

    this.getProviders(
      this.nombreServicio,
      this.categoriaServicio,
      this.locacion
    );
  }

  private _filter(nombre: string): any[] {
    const filterValue = nombre.toLowerCase();
    return this.providerList.filter((option: any) =>
      option.nombre?.toLowerCase().includes(filterValue)
    );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getProviders(
    nombreServicio: string,
    categoriaServicio: string,
    locacion: string
  ) {
    this.isLoading = true;
    this.providersMessage = null;
    this.providersEmpty = false;
    this.nombreServicioInvalid = false;
    this.providerList = [];

    this.fileService
      .getProvidersByService(
        nombreServicio || '',
        categoriaServicio || '',
        locacion || ''
      )
      .subscribe({
        next: (envelope: GetProvidersByServiceEnvelope) => {
          this.applyProvidersEnvelope(envelope);
          this.isLoading = false;
        },
        error: (err) => {
          const clientError = toProvidersByServiceClientError(err);
          this.providerList = [];
          this.providersEmpty = true;
          this.providersMessage = clientError.message;
          this.nombreServicioInvalid = clientError.validationNombreServicio;
          this.isLoading = false;
          void Swal.fire({
            icon: 'error',
            title: clientError.retryable ? 'Error' : 'Validación',
            text: clientError.message,
            confirmButtonText: 'Entendido'
          });
        }
      });
  }

  private applyProvidersEnvelope(
    envelope: GetProvidersByServiceEnvelope
  ): void {
    this.providersMessage = envelope.message || null;
    const rows = (envelope.data ?? []).filter(
      (item: any) => item?.nombre !== this.data.nombreProveedor
    );

    const nombresUnicos = new Set<string>();
    this.providerList = rows.filter((element: any) => {
      if (!element?.nombre || nombresUnicos.has(element.nombre)) {
        return false;
      }
      nombresUnicos.add(element.nombre);
      return true;
    }) as providerInfo[];

    if (isProvidersFound(envelope.code)) {
      this.providersEmpty = this.providerList.length === 0;
      if (envelope.message) {
        void Swal.fire({
          icon: 'info',
          title: 'Proveedores',
          text: envelope.message,
          timer: 2200,
          showConfirmButton: false,
          toast: true,
          position: 'top-end'
        });
      }
      return;
    }

    if (isProvidersEmptySuccess(envelope.code)) {
      this.providersEmpty = true;
      this.providerList = [];
      return;
    }

    // success con code desconocido: mostrar message y data si hay
    this.providersEmpty = this.providerList.length === 0;
  }

  saveChangeProvider() {
    if (this.data?.idRegistro && this?.myControl?.value.id) {
      this.fileService
        .changeProvider(
          this.data.idRegistro,
          this.myControl.value.id,
          this.user ? this.user.toString() : '',
          this.myControl.value.servicioId
        )
        .subscribe({
          next: (result) => {
            if (result?.changeProvider.success) {
              this.iconResult = true;
              this.messageResult = 'Proveedor Actualizado';
            } else {
              this.messageResult =
                result?.changeProvider.message || 'Ocurrió un Error';
              this.iconResult = false;
            }
          },
          error: () => {
            this.iconResult = false;
            this.messageResult = 'Ocurrió un Error';
            this.isLoadingResult = false;
            this.showModal = true;
            setTimeout(() => {
              this.dialogRef.close();
              this.showModal = false;
            }, 2000);
          },
          complete: () => {
            this.showModal = true;
            this.isLoadingResult = false;
            this.service.disparadorCambios.emit(this.data.secction);

            setTimeout(() => {
              this.dialogRef.close();
              this.showModal = false;
            }, 2000);
          }
        });
    } else {
      this.dialogRef.close();
    }
  }

  getOptionText(option: any) {
    return option.nombre;
  }
}
